import React, { useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";

const useStyles = makeStyles(() => ({
  root: {
    flex: "none",
    "& .MuiButtonBase-root": {
      width: "100%",
      height: 44,
      borderRadius: "100px",
      fontSize: 12,
      fontWeight: 600,
      textTransform: "none !important",
      fontFamily: "Montserrat",
      background: "#F8FAFB",
      color:
        "var(--azure-chatbot-root-button-text-color, var(--Primary-Blue---500, #006298))",
      "&:hover": {
        background:
          "var(--azure-chatbot-root-button-hover-background, var(--Primary-Blue---400, #118AC7))",
        color:
          "var(--azure-chatbot-root-button-interaction-text-color, white) !important",
      },
      "&:active": {
        background: "var(--azure-chatbot-root-button-active-background, #075080)",
        color:
          "var(--azure-chatbot-root-button-interaction-text-color, white) !important",
      },
      "&:focus": {
        background:
          "var(--azure-chatbot-root-button-selected-background, #006298)",
        color:
          "var(--azure-chatbot-root-button-interaction-text-color, white) !important",
      },
    },
    "& .MuiButton-startIcon": {
      marginLeft: 0,
      marginRight: 8,
    },
    "& .MuiButton-startIcon > *:nth-of-type(1)": {
      fontSize: 18,
    },
    "& .MuiButton-contained": {
      background:
        "var(--azure-chatbot-root-button-selected-background, #006298)",
      color:
        "var(--azure-chatbot-root-button-interaction-text-color, white) !important",
      "&:hover, &:focus, &.Mui-focusVisible": {
        background:
          "var(--azure-chatbot-root-button-selected-background, #006298)",
        color:
          "var(--azure-chatbot-root-button-interaction-text-color, white) !important",
      },
    },
    "& .MuiButton-outlined": {
      border: "1px solid var(--Neutral-Gray---100, #DAE2EA)",
    },
  },
}));

export function CustomButton({
  element,
  variant,
  className,
  onClick,
  children,
  disabled,
  ref,
  startIcon,
  endIcon,
  type,
}) {
  const classes = useStyles();
  const buttonRef = useRef(null);

  useEffect(() => {
    if (element?.focus) {
      buttonRef.current.focus();
    }
  }, []);
  return (
    <div className={classes.root}>
      <Button
        onClick={onClick ? () => onClick(element) : () => {}}
        variant={variant}
        className={className}
        disabled={disabled}
        ref={buttonRef}
        startIcon={startIcon}
        endIcon={endIcon}
        type={type}
      >
        {element && element.title}
        {children}
      </Button>
    </div>
  );
}
